
import moment from 'moment'

export default ({ directions, pricing, ...obj }) => {
  const directionsWithInfo = directions.map(({ segments, duration }) => {
    const segmentsLength = segments.length
    const firstSegment = segments[0]
    const lastSegment = segments[segmentsLength - 1]

    return {
      showSegments: false,
      segments,
      duration,
      info: {
        cityFrom: firstSegment.departure.city.slug,
        cityTo: lastSegment.arrival.city.slug,
        airportFrom: firstSegment.departure.airport.iataCode,
        airportTo: lastSegment.arrival.airport.iataCode,
        startDate: moment.unix(firstSegment.departure.time).format('D MMM dd').replace('.', ','),
        startTime: moment.unix(firstSegment.departure.time).format('HH:MM'),
        endDate: moment.unix(lastSegment.arrival.time).format('D MMM dd').replace('.', ','),
        endTime: moment.unix(lastSegment.arrival.time).format('HH:MM')
      }
    }
  })

  return {
    ...obj,
    directions: directionsWithInfo,
    showTarrifs: false,
    tarrifs: {
      isLoading: true,
      hasError: false,
      collection: [],
      errors: []
    },
    rules: {
      isLoading: true,
      hasError: false,
      collection: [],
      errors: []
    },
  }
}